/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
// import ChatBox from '../chatbot/ChatBox';
import Constant from '@/common/constant/Constant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import ChatBoxComponent from '@/component/publicPages/chatBot/ChatBoxComponent';
import { getPublicAPI } from '@/service/publicService';
import { updatePreviewSettingAtom } from '@/state/atom/chatBotPreview';
import { useRecoilValue } from 'recoil';
import LoadingPanel from '@/component/common/LoadingPanel';
import './PreviewChatBot.css';

export default function PreviewChatBot(props) {
    const previewSetting = useRecoilValue(updatePreviewSettingAtom);
    const [infoSettingPublicKnowledge, setInfoSettingPublicKnowledge] = useState({});
    const subDomain = localStorageUtil.getCorporationDomain();
    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        let isMounted = true;
        if(isMounted) {
            (async () => {
                let params = {
                    getApiType: Constant.GET_API_PUBLIC_TYPE.PREPARE_DATA_SETTING_PUBLIC_KNOWLEDGE,
                    subDomain: subDomain,
                    projectAlias: previewSetting?.projectAlias,
                    isModePreview: true,
                };
                setIsLoading(true);
                let result = await getPublicAPI(props?.API, params);
                let payload = Utils.convertJSONDataToObject(result.payload);
                setInfoSettingPublicKnowledge(payload);
                setIsLoading(false);
    
            })();
        }

        return () => {
            isMounted = false;
        }
    }, [props.triggerReload]);
    //TODO: thiếu dependencies

    useEffect(() => {
        // logic
        setInfoSettingPublicKnowledge({ ...infoSettingPublicKnowledge });
        // using for preview styleSheet

        const styleId = 'preview-chatbot-style';

        let existingStyleTag = document.getElementById(styleId);

        if (existingStyleTag) {
            existingStyleTag.remove();
        }
        var htmlObject = document.createElement('style');
        htmlObject.id = styleId;
        htmlObject.innerHTML = `.preview-box {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
            } 
            .preview-box {${previewSetting?.styleSheet}}`;
        document.head.appendChild(htmlObject);
    }, [previewSetting]);

    return (
        <div style={{height: '100%'}}>
            {isLoading ? <LoadingPanel isLoading={isLoading} /> : (
                <ChatBoxComponent 
                    API={props?.API}
                    projectId={previewSetting?.projectAlias} 
                    subDomain={subDomain} 
                    publicKnowledgeSetting={infoSettingPublicKnowledge?.publicKnowledgeSiteSetting}
                    isModePreview={true}
                />
            )}
            
        </div>
        
       
    );
}
